import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { useHasScope } from '../features/accounts/accountsQueries';
import UsageTracker from '../utils/UsageTracker';
import { SCREENS } from '../constants/Tracking';
import AcademyLabsLandingPage from '../features/academyLabs/components/AcademyLabsLandingPage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AcademyLabs = () => {
  const {
    hasScope,
    gatesAndScopesLoading
  } = useHasScope('academy-lab-portal-provisioning-access');
  useEffect(() => {
    if (hasScope) {
      UsageTracker.trackStandalone('Pageview', {
        screen: SCREENS.ACADEMY_LABS
      });
    }
  }, [hasScope]);
  if (gatesAndScopesLoading) return null;
  if (!hasScope) {
    return /*#__PURE__*/_jsx(View, {
      marginInline: "auto",
      maxInlineSize: "900px",
      paddingBlockStart: "1100",
      children: /*#__PURE__*/_jsx(CardWrapper, {
        children: /*#__PURE__*/_jsx(CardSection, {
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            flexDirection: "column",
            paddingBlock: "700",
            children: [/*#__PURE__*/_jsx(Pictogram, {
              name: "Unlock",
              size: "md"
            }), /*#__PURE__*/_jsxs(View, {
              marginBlockStart: "700",
              textAlign: "center",
              children: [/*#__PURE__*/_jsx(Text, {
                marginBlockEnd: "300",
                typography: "heading-400",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.academyLabs.noScope.heading"
                })
              }), /*#__PURE__*/_jsx(Text, {
                typography: "body-200",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.academyLabs.noScope.subheading"
                })
              })]
            })]
          })
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(AcademyLabsLandingPage, {});
};
export default AcademyLabs;